// src/core/challengeBoot.ts
// Pure boot-time helper: read `?c=DAY.SCORE` from the URL search string and,
// when it targets today's puzzle, persist it on the record so a mid-game
// reload keeps the head-to-head comparison.

import type { ChallengeContext, GameRecord } from '../types';
import { parseChallengeFromUrl } from './challenge';
import { daysSinceEpoch } from './puzzle';

export function applyChallengeFromSearch(
  rec: GameRecord,
  search: string,
  todayIso: string,
): { rec: GameRecord; arrived: ChallengeContext | null } {
  const arrived = parseChallengeFromUrl(search, daysSinceEpoch(todayIso));
  if (!arrived) return { rec, arrived: null };
  return { rec: { ...rec, challenge: arrived }, arrived };
}
